import { render, staticRenderFns } from "./RawDiagramBox.vue?vue&type=template&id=313ce258&scoped=true&"
import script from "./RawDiagramBox.vue?vue&type=script&lang=ts&"
export * from "./RawDiagramBox.vue?vue&type=script&lang=ts&"
import style0 from "./RawDiagramBox.vue?vue&type=style&index=0&id=313ce258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ce258",
  null
  
)

export default component.exports